// Enums y labels del Growth Kanban — deben reflejar exactamente los mismos valores que
// backend/growth.py (SOURCES, PRIORITIES, TYPES, COLUMNS, CLOSE_REASONS, ACTIVITY_TYPES).

export const COLUMNS = ["NEW", "TO_CONTACT", "IN_CONVERSATION", "REGISTERED", "CLOSED"];
export const COLUMN_LABELS = {
  NEW: "Nuevas", TO_CONTACT: "Contactar", IN_CONVERSATION: "En conversación",
  REGISTERED: "Registrado", CLOSED: "Cerrado",
};

export const SOURCES = ["FACEBOOK", "REDDIT", "YOUTUBE", "X", "UPWORK", "FORUM", "COMMUNITY", "AFFILIATE", "EMAIL", "OTHER"];
export const SOURCE_LABELS = {
  FACEBOOK: "Facebook", REDDIT: "Reddit", YOUTUBE: "YouTube", X: "X", UPWORK: "Upwork",
  FORUM: "Foro", COMMUNITY: "Comunidad", AFFILIATE: "Afiliado", EMAIL: "Email", OTHER: "Otro",
};

export const PRIORITIES = ["LOW", "MEDIUM", "HIGH", "VERY_HIGH"];
export const PRIORITY_LABELS = { LOW: "Baja", MEDIUM: "Media", HIGH: "Alta", VERY_HIGH: "Muy alta" };
export const PRIORITY_COLORS = {
  VERY_HIGH: "border-red-300 bg-red-100 text-red-700",
  HIGH: "border-orange-200 bg-orange-100 text-orange-700",
  MEDIUM: "border-amber-200 bg-amber-100 text-amber-700",
  LOW: "border-slate-200 bg-slate-100 text-slate-500",
};

export const TYPES = ["LOOKING_FOR_TOOL", "COMPETITOR_PROBLEM", "EXISTING_FACELESS_CHANNEL",
  "MANUAL_WORKFLOW", "AFFILIATE", "COMMUNITY", "AGENCY", "FREELANCE_BUYER", "OTHER"];
export const TYPE_LABELS = {
  LOOKING_FOR_TOOL: "Busca herramienta", COMPETITOR_PROBLEM: "Problema con competidor",
  EXISTING_FACELESS_CHANNEL: "Canal faceless existente", MANUAL_WORKFLOW: "Flujo manual",
  AFFILIATE: "Afiliado", COMMUNITY: "Comunidad", AGENCY: "Agencia",
  FREELANCE_BUYER: "Comprador freelance", OTHER: "Otro",
};

export const CLOSE_REASONS = ["CUSTOMER", "NOT_INTERESTED", "NO_RESPONSE", "NOT_QUALIFIED", "DUPLICATE", "OTHER"];
export const CLOSE_REASON_LABELS = {
  CUSTOMER: "Cliente", NOT_INTERESTED: "No interesado", NO_RESPONSE: "No respondió",
  NOT_QUALIFIED: "No cualificado", DUPLICATE: "Duplicado", OTHER: "Otro",
};

export const ACTIVITY_TYPES = ["CREATED", "UPDATED", "COLUMN_CHANGED", "COMMENT_POSTED", "DM_SENT",
  "EMAIL_SENT", "PROPOSAL_SENT", "REPLY_RECEIVED", "FOLLOW_UP", "REGISTERED", "ACTIVATED",
  "CUSTOMER", "NOTE", "OTHER"];
export const ACTIVITY_TYPE_LABELS = {
  CREATED: "Creada", UPDATED: "Actualizada", COLUMN_CHANGED: "Cambio de columna",
  COMMENT_POSTED: "Comentario publicado", DM_SENT: "DM enviado", EMAIL_SENT: "Email enviado",
  PROPOSAL_SENT: "Propuesta enviada", REPLY_RECEIVED: "Respuesta recibida", FOLLOW_UP: "Seguimiento",
  REGISTERED: "Se registró", ACTIVATED: "Se activó", CUSTOMER: "Se convirtió en cliente",
  NOTE: "Nota", OTHER: "Otro",
};

// Solo http/https — un sourceUrl arbitrario no debe poder colarse como href javascript:.
export function safeExternalUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    if (u.protocol === "http:" || u.protocol === "https:") return url;
  } catch { /* URL inválida */ }
  return null;
}

export function fmtShortDate(iso) {
  if (!iso) return null;
  try { return new Date(iso).toLocaleDateString("es-ES", { day: "numeric", month: "short" }); }
  catch { return null; }
}

export function fmtDateTime(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString("es-ES", {
      day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return null; }
}
